<template>
  <div>
    <el-dialog
      title="Transaction Details"
      :visible.sync="show"
      :label-position="labelPosition"
      :before-close="handleClose"
    >
      <el-form label-width="180px" class="demo-ruleForm" size="mini">
        <el-form-item label="Transaction Hash : ">
          <label for>{{data.transaction_code}}</label>
        </el-form-item>
        <el-form-item label="Status : ">
          <label for>success</label>
        </el-form-item>
        <el-form-item label="Block : ">
          <label for>{{data.block_number}}</label>
        </el-form-item>
        <el-form-item label="Timestamp : ">
          <label for>{{data.created_at}}</label>
        </el-form-item>
        <el-form-item label="From : ">
          <label for>{{data.from_address}}</label>
        </el-form-item>
        <el-form-item label="To : ">
          <label for>{{data.to_address}}</label>
        </el-form-item>
        <el-form-item label="Value : ">
          <el-link type="primary"  href="/Admin/Report_blockchainDetail" target="_blank">
              ดูข้อมูล
          </el-link>
        </el-form-item>
        <el-form-item label="Nonce : ">
          <label for="">26</label>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      labelPosition: "top",
      show: false
    };
  },
  created() {
    //do something after creating vue instance
  },
  watch: {
    dialog() {
      this.show = this.dialog;
    }
  },
  props: ["dialog", "data"],
  methods: {
    //   new_tap(){
    //        window.open()
    //   },
    handleClose(done) {
      this.$emit("checkModal", false);
      done();
    }
  }
};
</script>
